<div class="fund-literature-table-wrapper table-content-center" #pdfContainer>
  <div *ngIf="isShowTable" class="fund-literature-download-btn d-flex justify-content-start justify-content-lg-end c11n-space--force c11n-space-stack-2_5x">
    <c11n-button
      [size]="'medium'"
      [variant]="'primary'"
      [labelText]="'Download'"
      [iconName]="'download'"
      ariaLabelText="Download" role="button"
      (clickEvent)="downloadPDF()"
      [class.disabled]="selectedPdf.size === 0"
      *ngIf="selectedPdf.size !== 0"
      [attr.inert]="selectedPdf.size === 0 ? true : null"
    ></c11n-button>
  </div>
  <div class="sr-only" aria-live="polite">{{ announcement }}</div>
  <div class="fund-literature-table-spinner d-flex align-items-center justify-content-center" *ngIf="isShowLoader">
    <c11n-spinner [size]="'medium'" [colorMode]="'on-light'" [spinnerStatus]="'Loading...'"></c11n-spinner>
  </div>
  <div class="c11n-table__symbols">
  </div>
  <div *ngIf="!(fundLiteratureData.length === 0 && isServiceAvailable)" id="performance-table-updated-announcement" class="sr-only" aria-live="polite">
    {{ updateMessage }}
  </div>
  <table *ngIf="isShowTable"
         c11n-data-table
         [rowHighlight]="true"
         [headerDividers]="true"
         (tableSortEvent)="handleSortEvent($event)"
         class="c11n-table c11n-table--medium funds-table--wrapper"
         aria-label="This is a fund-literature table summary">
    <thead class="c11n-text-sm table-header-sticky">
    <tr c11n-thead-tr class="c11n-table__tr table-main-header">
      <th id="fund-name-header" scope="col" rowspan="2" c11n-thead-th alignment="left" [isAscending]="true" [isSortable]="true">
        <span>{{literatureTableLabelCaas.fundName}}</span>
      </th>
      <th id="symbol-header" scope="col" rowspan="2" c11n-thead-th alignment="left" [isSortable]="true">
        <span>{{literatureTableLabelCaas.symbol}}</span>
      </th>
      <th id="fact-sheet-header" scope="col" rowspan="2" c11n-thead-th alignment="left" [isSortable]="false">
        <span>{{literatureTableLabelCaas.factSheet}}</span>
      </th>
      <th id="investment-profile-header" scope="col" rowspan="2" c11n-thead-th alignment="left" [isSortable]="false">
        <span>{{literatureTableLabelCaas.investmentProfile}}</span>
      </th>
      <th id="summary-prospectus-header" scope="col" rowspan="2" c11n-thead-th alignment="left" [isSortable]="false">
        <span>{{literatureTableLabelCaas.summaryProspectus}}</span>
      </th>
      <th id="prospectus-header" scope="col" rowspan="2" c11n-thead-th alignment="left" [isSortable]="false">
        <span>{{literatureTableLabelCaas.prospectus}}</span>
      </th>
      <th id="sai-header" scope="col" rowspan="2" c11n-thead-th alignment="left" [isSortable]="false">
        <span>{{literatureTableLabelCaas.sai}}</span>
      </th>
      <th id="semiannual-report-header" scope="col" rowspan="2" c11n-thead-th alignment="left" [isSortable]="false">
        <span>{{literatureTableLabelCaas.semiannualReport}}</span>
      </th>
      <th id="annual-report-header" scope="col" rowspan="2" c11n-thead-th alignment="left" [isSortable]="false">
        <span>{{literatureTableLabelCaas.annualReport}}</span>
      </th>
      <th id="investment-commentary-header" scope="col" rowspan="2" c11n-thead-th alignment="left" [isSortable]="false">
        <span>{{literatureTableLabelCaas.investmentCommentary}}</span>
      </th>
    </tr>
    </thead>

    <tbody class="c11n-text-sm" *ngIf="isServiceAvailable">
    <tr tabindex="-1" [attr.data-rpa-tag-id]="'fl-' + fund.ticker" c11n-tbody-tr *ngFor="let fund of fundLiteratureData | sort:sortBy; index as indexValue;">
      <td id="fund-name-value-{{indexValue}}"  c11n-tbody-td alignment="left">
        <a href="{{productDetails}}{{fund.fundID}}" class="c11n-link c11n-link--secondary c11n-link--independent mt-1">
              <span class="c11n-link__content">
                <span data-rpa-tag-id="fl-longName" class="c11n-link__text">{{fund.fundName}}</span>
              </span>
        </a>
        <span *ngIf="fund.isClosedFund">&nbsp;</span>
        <img class="c11n-card--image-1-1 closed-Indicator" role="button" title="Closed" *ngIf="fund.isClosedFund" alt="Closed"
             src="{{literatureTableLabelCaas.closedImage}}">
        <div class="c11n-text fee-content">
          <em>
            <div class ="c11n-link__text" *ngIf="fund.purchaseFeeDisplay" [innerHtml]= "literatureTableLabelCaas.purchaseFee + ': ' + (fund.purchaseFeeDisplay | percentage)"></div>
            <div class = "c11n-link__text" *ngIf="fund.reedemptionFeeDisplay" [innerHtml]= "literatureTableLabelCaas.redemptionFee + ': ' + (fund.reedemptionFeeDisplay | percentage)"></div>
          </em>
        </div>
      </td>
      <td data-rpa-tag-id="fl-symbol" id="symbol-value-{{indexValue}}" c11n-tbody-td alignment="left">{{ fund.ticker }}</td>
      <td id="fact-sheet-value-{{indexValue}}" c11n-tbody-td alignment="left">
          <span *ngIf="fund.factSheetDate">
            <input
              type="checkbox"
              class="custom-checkbox"
              [id]="'fact-sheet-value-' + fund.rowId"
              name="factSheet"
              (click)="selectPdf(fund.factSheet, 'fact-sheet-value-' + fund.rowId, 'factSheet', fund.longNm, $event)"
            />
            <!-- commented below label recommended by accessibility due to literature performance issue on all share class checkbox-->
<!--            <label class="sr-only" for="fact-sheet-value-{{fund.rowId}}"></label>-->
            </span>
        <span *ngIf="!fund.factSheetDate">
          {{literatureTableLabelCaas.notAvailable}}
<!--          <span class="sr-only">&nbsp; {{ NOT_AVAILABLE }}</span>-->
        </span>
      </td>
      <td id="investment-profile-value-{{indexValue}}" c11n-tbody-td alignment="left">
          <span *ngIf="fund.invProfDate">
            <input id="investment-profile-value-{{fund.rowId}}" type="checkbox" name="investmentProfile" class="custom-checkbox" (click)="selectPdf(fund.investmentProfile, 'investment-profile-value-' + fund.rowId, 'invProf',fund.longNm, $event)" />
<!--            <label class="sr-only" for="investment-profile-value-{{fund.rowId}}"></label>-->
          </span>
        <span *ngIf="!fund.invProfDate">
          {{literatureTableLabelCaas.notAvailable}}
<!--          <span class="sr-only">&nbsp; {{ NOT_AVAILABLE }}</span>-->
        </span>
      </td>
      <td id="summary-value-{{indexValue}}" c11n-tbody-td alignment="left">
          <span *ngIf="fund.summaryVal">
            <input id="summary-prospectus-value-{{fund.rowId}}" type="checkbox" name="summaryProspectus" class="custom-checkbox" (click)="selectPdf(fund.summaryVal, 'summary-prospectus-value-' + fund.rowId, 'summaryVal',fund.longNm, $event)" />
<!--            <label class="sr-only" for="summary-prospectus-value-{{fund.rowId}}"></label>-->
          </span>
        <span *ngIf="!fund.summaryVal">
          {{literatureTableLabelCaas.notAvailable}}
<!--          <span class="sr-only">&nbsp; {{ NOT_AVAILABLE }}</span>-->
        </span>
      </td>
      <td id="prospectus-value-{{indexValue}}" c11n-tbody-td alignment="left">
          <span *ngIf="fund.prospectus">
            <input id="prospectus-value-{{fund.rowId}}" type="checkbox" name="prospectus" class="custom-checkbox" (click)="selectPdf(fund.prospectus, 'prospectus-value-' + fund.rowId, 'prospectus',fund.longNm, $event)" />
<!--            <label class="sr-only" for="prospectus-value-{{fund.rowId}}"></label>-->
          </span>
        <span *ngIf="!fund.prospectus">
          {{literatureTableLabelCaas.notAvailable}}
<!--          <span class="sr-only">&nbsp; {{ NOT_AVAILABLE }}</span>-->
        </span>
      </td>
      <td id="sai-value-{{indexValue}}" c11n-tbody-td alignment="left">
          <span *ngIf="fund.sai">
            <input id="sai-value-{{fund.rowId}}" type="checkbox" name="sai" class="custom-checkbox" (click)="selectPdf(fund.sai, 'sai-value-' + fund.rowId, 'sai',fund.longNm, $event)" />
<!--            <label class="sr-only" for="sai-value-{{fund.rowId}}"></label>-->
          </span>
        <span *ngIf="!fund.sai">
          {{literatureTableLabelCaas.notAvailable}}
<!--          <span class="sr-only">&nbsp; {{ NOT_AVAILABLE }}</span>-->
        </span>
      </td>
      <td id="semi-annual-report-value-{{indexValue}}" c11n-tbody-td alignment="left">
          <span *ngIf="fund.semiAnnualReportDate && fund.semiAnnualReportDate != percentSign">
            <input id="semiannual-report-value-{{fund.rowId}}" type="checkbox" name="semiannualReport" class="custom-checkbox" (click)="selectPdf(fund.semiAnnualReport, 'semiannual-report-value-' + fund.rowId, 'semiAnnualReport',fund.longNm, $event)" />
<!--            <label class="sr-only" for="semiannual-report-value-{{fund.rowId}}"></label>-->
          </span>
        <span *ngIf="!fund.semiAnnualReportDate || fund.semiAnnualReportDate == percentSign">
          {{literatureTableLabelCaas.notAvailable}}
<!--          <span class="sr-only">&nbsp; {{ NOT_AVAILABLE }}</span>-->
        </span>
      </td>
      <td id="annual-report-value-{{indexValue}}" c11n-tbody-td alignment="left">
          <span *ngIf="fund.annualReportDate && fund.annualReportDate != percentSign">
            <input id="annual-report-value-{{fund.rowId}}" type="checkbox" name="annualReport" class="custom-checkbox" (click)="selectPdf(fund.annualReport, 'annual-report-value-' + fund.rowId, 'annualReport', fund.longNm, $event)" />
<!--            <label class="sr-only" for="annual-report-value-{{fund.rowId}}"></label>-->
          </span>
        <span *ngIf="!fund.annualReportDate || fund.annualReportDate == percentSign">
          {{literatureTableLabelCaas.notAvailable}}
<!--          <span class="sr-only">&nbsp; {{ NOT_AVAILABLE }}</span>-->
        </span>
      </td>
      <td id="investment-commentary-value-{{indexValue}}" c11n-tbody-td alignment="left">
          <span *ngIf="fund.invComDate && fund.invComDate != percentSign">
            <input id="investment-commentary-value-{{fund.rowId}}" type="checkbox" name="investmentCommentary" class="custom-checkbox" (click)="selectPdf(fund.investmentCommentary, 'investment-commentary-value-' + fund.rowId, 'invCom',fund.longNm, $event)" />
<!--            <label class="sr-only" for="investment-commentary-value-{{fund.rowId}}"></label>-->
          </span>
        <span *ngIf="!fund.invComDate || fund.invComDate == percentSign">
          {{literatureTableLabelCaas.notAvailable}}
<!--          <span class="sr-only">&nbsp; {{ NOT_AVAILABLE }}</span>-->
        </span>
      </td>
    </tr>
    </tbody>
  </table>
  <br>
  <div *ngIf="fundLiteratureData.length === 0 && isServiceAvailable">
    <fd3-banner-error></fd3-banner-error>
  </div>
</div>
